import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

export function getErrorMessage(error: unknown) {
  if (typeof error === 'string') {
    return error;
  }

  if (isFetchBaseQueryError(error)) {
    const data = error.data;

    if (typeof data === 'string') {
      return data;
    }

    if (data && typeof data === 'object') {
      if (typeof (data as { message?: string }).message === 'string') {
        return (data as { message: string }).message;
      }

      const firstEntry = Object.values(data)[0];
      if (Array.isArray(firstEntry) && typeof firstEntry[0] === 'string') {
        return firstEntry[0];
      }
    }

    return `Request failed (${String(error.status)})`;
  }

  if (isSerializedError(error)) {
    return error.message ?? 'Something went wrong, please try again.';
  }

  if (error instanceof Error) {
    return error.message;
  }

  return 'Something went wrong, please try again.';
}

function isFetchBaseQueryError(error: unknown): error is FetchBaseQueryError {
  return typeof error === 'object' && error !== null && 'status' in error;
}

function isSerializedError(error: unknown): error is SerializedError {
  return typeof error === 'object' && error !== null && 'message' in error;
}
